import validate from "/app/node_modules/.pnpm/nuxt@3.17.5_@deno+kv@0.12.0_@parcel+watcher@2.5.1_@types+node@22.15.30_db0@0.3.2_eslint@9.28._wheeikyoin4imv5q2gbo7v5awe/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.5_@deno+kv@0.12.0_@parcel+watcher@2.5.1_@types+node@22.15.30_db0@0.3.2_eslint@9.28._wheeikyoin4imv5q2gbo7v5awe/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "check-product-slug": () => import("/app/middleware/check.product.slug.ts"),
  "search-guard": () => import("/app/middleware/search.guard.ts")
}